export const Services = {
  Student: 1,
  Resident: 2
};

export const ServiceCategory = {
  CityRegistration: 1,
  BankAccount: 2,
  Insurance: 3,
  SimCard: 4,
  LanguageSchool: 5,
  ResidentInsurance: 7,
  ResidentBankAccount: 10
};

export const ServiceCategoryLabels = {
  [ServiceCategory.CityRegistration]: "City Registration",
  [ServiceCategory.BankAccount]: "Bank Account",
  [ServiceCategory.Insurance]: "Insurance",
  [ServiceCategory.SimCard]: "SIM Card",
  [ServiceCategory.LanguageSchool]: "Language School",
  [ServiceCategory.ResidentInsurance]: "Resident Insurance",
  [ServiceCategory.ResidentBankAccount]: "Resident Bank Account"
};

export const ServicesLabels = {
  [Services.Student]: "Student",
  [Services.Resident]: "Resident"
};

// Approval Status Enum (API: PENDING, APPROVED, DECLINE, INACTIVE — use DECLINE; REJECTED kept as alias for display/backward compat)
export const ApprovalStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DECLINE: 'DECLINE',
  REJECTED: 'DECLINE',
  INACTIVE: 'INACTIVE'
};

// Approval Status Labels for UI
export const ApprovalStatusLabels = {
  [ApprovalStatus.PENDING]: 'Pending',
  [ApprovalStatus.APPROVED]: 'Approved',
  [ApprovalStatus.DECLINE]: 'Decline',
  [ApprovalStatus.INACTIVE]: 'Inactive'
};

// API Field Name for Approval Status
export const APPROVAL_STATUS_FIELD = 'ApprovalStatus';
